import React from 'react'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import CoachProfileEmptyState from './coach-profile-empty-state'
import ProfileOverview from './profile-overview'
import { useStyles } from './styles'

const CoachProfileView = ({ coachProfile }) => {
  const classes = useStyles()
  const hasCoachProfile = coachProfile != null

  return (
    <Grid container spacing={1}>
      <Grid container className={classes.coachProfileCardsContainer}>
        <Grid item xs={12}>
          {hasCoachProfile ? (
            <ProfileOverview hasCoachProfile />
          ) : (
            <Box className={classes.emptyStateContent}>
              <CoachProfileEmptyState />
            </Box>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CoachProfileView
